/* ==================================================================
   main-product.js
   ================================================================== */

const siteHeader = document.getElementById("shopify-section-header");
const headerUspBar = document.getElementById("shopify-section-usp-bar");
const productSection = document.querySelector(".section-product");
const productWrapper = productSection ? productSection.querySelector(".wrap") : null;
const productDetails = productSection ? productSection.querySelector(".section-product__details") : null;

let headerHeight = 0;
let headerUspBarHeight = 0;
let productDetailsHeight = 0;
let wrapperPadding = 0;

/* ------------------------------------------------------------------
   Sticky product details column (desktop, 1024px and up)

   Works out how far from the top of the screen the details column
   should stick, so it sits below the header and USP bar and never
   runs off the bottom of the screen when it is taller than the view.

   FIX: the original code passed the RESULT of heightFromTop(...) to
   addEventListener instead of the function itself, so it only ran once
   on load and never again on resize or scroll. It now runs on load,
   resize, scroll and whenever the column changes height (e.g. an
   accordion opens), throttled to once per frame.
   ------------------------------------------------------------------ */
const heightFromTop = (width) => {
    if (!productDetails) return;

    if (width >= 1024) {
        const viewportHeight = window.innerHeight;

        productDetailsHeight = productDetails.offsetHeight;
        if (siteHeader) headerHeight = siteHeader.offsetHeight;
        if (headerUspBar) headerUspBarHeight = headerUspBar.offsetHeight;
        if (productWrapper) {
            wrapperPadding = window.getComputedStyle(productWrapper, null).getPropertyValue("padding-top");
        }

        const padding = parseFloat(String(wrapperPadding).replace("px", "")) || 0;
        const offsetTop = headerHeight + headerUspBarHeight + padding;
        const availableHeight = viewportHeight - offsetTop;

        let top;
        if (availableHeight > productDetailsHeight) {
            // Column fits on screen: stick just below the header
            top = offsetTop;
        } else {
            // Column is taller than the screen: stick so its bottom stays visible
            top = offsetTop - (productDetailsHeight - availableHeight);
        }

        productDetails.style.top = top + "px";
        productDetails.style.position = "sticky";
    } else {
        productDetails.style.position = "relative";
        productDetails.style.top = "auto";
    }
};

let heightFrame = null;
const scheduleHeightFromTop = () => {
    if (heightFrame) return;
    heightFrame = window.requestAnimationFrame(() => {
        heightFrame = null;
        heightFromTop(window.innerWidth);
    });
};

heightFromTop(window.innerWidth);
window.addEventListener("DOMContentLoaded", scheduleHeightFromTop);
window.addEventListener("load", scheduleHeightFromTop);
window.addEventListener("resize", scheduleHeightFromTop);
window.addEventListener("scroll", scheduleHeightFromTop, { passive: true });

if (productDetails && "ResizeObserver" in window) {
    new ResizeObserver(scheduleHeightFromTop).observe(productDetails);
}

/* ------------------------------------------------------------------
   Sticky add-to-cart bar: show / hide (mobile)
   snippets/product-sticky-atc.liquid does the same for all screen
   sizes, so this is kept only for backwards compatibility.
   ------------------------------------------------------------------ */
const initStickyForm = () => {
    const actions = document.querySelector(".section-product__details__actions");
    const stickyForm = document.querySelector(".sticky-form");
    if (!actions || !stickyForm) return;

    window.addEventListener("scroll", () => {
        if (actions.getBoundingClientRect().top < 0) {
            stickyForm.classList.remove("hidden");
        } else {
            stickyForm.classList.add("hidden");
        }
    }, { passive: true });
};

if (window.innerWidth < 1024) initStickyForm();

/* ------------------------------------------------------------------
   Sticky add-to-cart bar: Add to basket button

   FIX (double add to cart): this file used to attach its own click
   handler to the sticky bar's button, which clicked the main Add to
   basket button. snippets/product-sticky-atc.liquid does the same, so
   every click added the product twice. The snippet now owns this
   button (with a double-click lock), so the duplicate handler that
   used to be here has been removed.
   ------------------------------------------------------------------ */

/* ------------------------------------------------------------------
   Gift card: "Email to me" / "Email to them" toggle
   (behaviour unchanged, debug console logs removed)
   ------------------------------------------------------------------ */
const emailToggleContainer = document.querySelector(".section-product__details__email");
const emailFields = document.querySelector(".email-recipient");

if (emailToggleContainer && emailFields) {
    const radios = emailToggleContainer.querySelectorAll('input[type="radio"]');
    const recipientInputs = emailFields.querySelectorAll(".email-recipient-input");

    for (const radio of radios) {
        radio.addEventListener("click", function () {
            if (radio.id == "switchThem") {
                emailFields.classList.remove("hidden");
                for (const input of recipientInputs) input.disabled = false;
            } else {
                emailFields.classList.add("hidden");
                for (const input of recipientInputs) input.disabled = true;
            }
        });
    }

    const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

    // Returns "failed" when "Email to them" is chosen and the email is invalid
    window.validateGiftVoucherEmailField = () => {
        const checked = emailToggleContainer.querySelector('input[type="radio"]:checked');
        if (!checked || checked.id != "switchThem") return;

        const emailInput = emailToggleContainer.querySelector('input[type="email"]');
        const isValid = validateEmail(emailInput ? emailInput.value : "");
        const alert = document.querySelector(".email-alert");

        if (!isValid) {
            if (alert) alert.classList.remove("hidden");
            return "failed";
        }
        if (alert) alert.classList.add("hidden");
    };

    const emailDateInput = document.getElementById("email-date-input");
    if (emailDateInput) {
        emailDateInput.addEventListener("change", function () {
            emailDateInput.classList.add("hide");
        });
    }
}